import { render } from "./AssessmentForm.vue?vue&type=template&id=49346d70&scoped=true"
import script from "./AssessmentForm.vue?vue&type=script&lang=js"
export * from "./AssessmentForm.vue?vue&type=script&lang=js"

import "./AssessmentForm.vue?vue&type=style&index=0&id=49346d70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49346d70"

export default script